import React from 'react';
import {
  Box,
  Container,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import './Footer.css';
import logo from './food-fe-alt.png';

const socialLinks = [
  {
    icon: <InstagramIcon sx={{ color: '#352b54' }} />,
    href: 'https://www.instagram.com/foodfeapp?igsh=cGc2cWp1N3BlZDJj&utm_source=qr',
  },
  {
    icon: <FacebookRoundedIcon sx={{ color: '#352b54' }} />,
    href: 'https://www.facebook.com/share/15T3RvPvZT/?mibextid=wwXIfr',
  },
  {
    icon: <LinkedInIcon sx={{ color: '#352b54' }} />,
    href: 'https://www.linkedin.com/company/97881015/admin/page-posts/published/',
  },
];

export const Footer = () => {
  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#352b54',
        color: '#FFFFFF',
        pt: { xs: 6, md: 8 },
        pb: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth='lg'>
        <Grid
          container
          spacing={{ xs: 5, md: 8 }}
          alignItems='center'
          justifyContent='space-between'
        >
          <Grid item xs={12} md={3}>
            <Stack
              spacing={1.5}
              alignItems={{ xs: 'center', md: 'flex-start' }}
              textAlign={{ xs: 'center', md: 'left' }}
            >
              <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
                Contact
              </Typography>
              <Link href='mailto:info@dcx.no' underline='none' color='#FFFFFF' sx={{ fontWeight: 500 }}>
                info@dcx.no
              </Link>
              <Link href='tel:+4746389345' underline='none' color='#FFFFFF' sx={{ fontWeight: 500 }}>
                tlf: +47 46 38 93 45
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack spacing={2} alignItems='center'>
              <Box component='img' src={logo} alt='FoodFe' sx={{ height: 72, width: 'auto' }} />
            </Stack>
          </Grid>

          <Grid item xs={12} md={3}>
            <Stack
              spacing={1.5}
              alignItems={{ xs: 'center', md: 'flex-end' }}
              textAlign={{ xs: 'center', md: 'right' }}
            >
              <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
                Follow Us
              </Typography>
              <Stack direction='row' spacing={1.5}>
                {socialLinks.map((item) => (
                  <IconButton
                    key={item.href}
                    component='a'
                    href={item.href}
                    target='_blank'
                    rel='noreferrer'
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: '50%',
                      backgroundColor: '#FFFFFF',
                      boxShadow: '0px 10px 20px rgba(0,0,0,0.18)',
                      '&:hover': {
                        backgroundColor: 'rgba(255,255,255,0.9)',
                      },
                    }}
                  >
                    {item.icon}
                  </IconButton>
                ))}
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Typography
          variant='body2'
          color='#FFFFFF'
          textAlign='center'
          sx={{ mt: { xs: 4, md: 6 }, fontWeight: 500 }}
        >
          Copyright ©{new Date().getFullYear()} FoodFe. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};
